import {
  ApiConfig,
  SlideTypeConfig,
  SlideTypeConfigs,
  DynamicRequestBody,
  SlideType,
  StatisticsData,
  TimelineData,
  ImagesData,
  TablesData,
  PeopleData,
  GraphsData,
} from "../types/apiTypes";

// Comprehensive slide type configurations with realistic example data
export const slideTypeConfigs: SlideTypeConfigs = {
  Points: {
    title: "Key Market Insights",
    data: {
      slideName: "Key Market Indicators",
      pointers: [
        "Price-to-Earnings (P/E) Ratio: Assesses stock valuation by comparing current price to earnings per share. High P/E may indicate overvaluation, low P/E undervaluation.",
        "Dividend Yield: Assesses annual dividends against stock price, reflecting income potential.",
        "Market Cap: Company's total value, found by multiplying stock price with outstanding shares.",
      ],
    },
  },
  Statistics: {
    title: "Performance Metrics",
    data: {
      slideName: "Why Beauty Product Sampling?",
      statistics: [
        {
          label: "Purchase Rate",
          value: "50% buy sampled product",
          period: "Current"
        },
        {
          label: "Millennial Engagement",
          value: "76% find samples fun",
          period: "Current"
        },
        {
          label: "Home Sampling Impact",
          value: "Encourages US shoppers",
          period: "Current"
        },
      ],
    } as StatisticsData,
  },
  Timeline: {
    title: "Product Development Roadmap",
    data: {
      slideName: "Unlock the Full Potential",
      events: [
        {
          date: "2030",
          title: "TAM",
          description: "42% by 2030",
        },
        {
          date: "2030",
          title: "SAM",
          description: "25% by 2030",
        },
        {
          date: "2030",
          title: "SOM",
          description: "12% by 2030",
        },
      ],
    } as TimelineData,
  },
  Images: {
    title: "Product Gallery",
    data: {
      slideName: "Unlock the Full Potential",
      header1: "male-graphic-designer-looking-document",
      header2: "cheerful-business-people-looking-digital-tablet",
      header3: "businessman-discussing-white-board-with-colleague",
      header4: "social-media-marketing-concept-marketing-with-applications",
      imageurl: [
        "https://zynthimage.s3.amazonaws.com/uploads/1754553604224_male-graphic-designer-looking-document.jpg",
        "https://zynthimage.s3.amazonaws.com/uploads/1754553604242_cheerful-business-people-looking-digital-tablet.jpg",
        "https://zynthimage.s3.amazonaws.com/uploads/1754553604247_businessman-discussing-white-board-with-colleague.jpg",
        "https://zynthimage.s3.amazonaws.com/uploads/1754553604251_social-media-marketing-concept-marketing-with-applications.jpg",
      ],
      title: "Business Images",
    } as any,
  },
  Tables: {
    title: "Quarterly Financial Summary",
    data: {
      slideName: 'Amika "The Kure" Analysis',
      title: 'Amika "The Kure" Analysis',
      rowHeader1: "Total Revenue",
      rowHeader2: "Number of Customers",
      rowHeader3: "Revenue per Customer",
      rowHeader4: "Leads per Week",
      rowHeader5: "Rating & Reviews per Week",
      rowHeader6: "ROI",
      rowHeader7: "Reach per Week",
      rowHeader8: "Total Budget",
      columnHeader1: "Value",
      columnHeader2: "Cost per Lead",
      columnHeader3: "Cost per Reach",
      columnHeader4: "CTR",
      columnHeader5: "Total Leads",
      rows1: {
        attribute1: "$253,444",
        attribute2: "445",
        attribute3: "178",
        attribute4: "12%",
        attribute5: "93k",
      },
      rows2: {
        attribute1: "1,690",
        attribute2: "-",
        attribute3: "-",
        attribute4: "-",
        attribute5: "-",
      },
      rows3: {
        attribute1: "$149.8",
        attribute2: "-",
        attribute3: "-",
        attribute4: "-",
        attribute5: "-",
      },
      rows4: {
        attribute1: "-",
        attribute2: "$2.5",
        attribute3: "-",
        attribute4: "-",
        attribute5: "20k",
      },
      rows5: {
        attribute1: "-",
        attribute2: "-",
        attribute3: "-",
        attribute4: "-",
        attribute5: "-",
      },
      rows6: {
        attribute1: "406.8%",
        attribute2: "-",
        attribute3: "-",
        attribute4: "-",
        attribute5: "-",
      },
      rows7: {
        attribute1: "-",
        attribute2: "-",
        attribute3: "$1.42",
        attribute4: "75.7%",
        attribute5: "-",
      },
      rows8: {
        attribute1: "$50,000",
        attribute2: "-",
        attribute3: "-",
        attribute4: "-",
        attribute5: "-",
      },
    } as any,
  },
  People: {
    title: "Leadership Team",
    data: {
      slideName: "About Wonka",
      title: "Team",
      people: [
        {
          name: "John Doe",
          designation: "Founder",
          company: "Wonka",
          description: "10 years of working experience in the industry.",
          image:
            "https://zynthimage.s3.amazonaws.com/uploads/1754554283102_african-man-black-suit.jpg",
        },
        {
          name: "Jacob Doe",
          designation: "Co-Founder",
          company: "Wonka",
          description: "12 years of marketing experience.",
          image:
            "https://zynthimage.s3.amazonaws.com/uploads/1754554330629_industrial-designers-working-3d-model.jpg",
        },
      ],
    } as any,
  },
  Graphs: {
    title: "Revenue Growth Analysis",
    data: {
      chartType: "pie",
      slideName: "Unlock the Power",
      chart: {
        series: [
          {
            key: "Categories",
            value: [
              "More qualified leads",
              "More ratings & reviews",
              "Superior QR Scan-Through Rate",
            ],
          },
          {
            key: "Values",
            value: ["31.2", "10.8", "4.4"],
          },
        ],
      },
    } as any,
  },

  TextandImage: {
    title: "About Wonka",
    data: {
      slideName: "About Wonka",
      header1: "male-graphic-designer-looking-document",
      image:
        "https://zynthimage.s3.amazonaws.com/uploads/1754552237806_male-graphic-designer-looking-document.jpg",
      overview:
        "Wonka is the first end-to-end Beauty sampling platform, transforming product samples into engaging, personalized experiences for consumers while providing brands with data-driven insights to enhance campaign efficiency.",
      title: "About Wonka",
    },
  },
};

// Helper function to generate dynamic request body based on slide type
export const generateRequestBody = (slideType: string): DynamicRequestBody => {
  const config = slideTypeConfigs[slideType];
  if (!config) {
    // Fallback to Points if slide type not found
    const pointsConfig = slideTypeConfigs.Points;
    return {
      type: SlideType.POINTS,
      title: pointsConfig.title,
      data: pointsConfig.data,
      presentationID: "1fZuoePN_QEyMJlkpac2-bRq0hQYmeAvAbm21a1FS-CM",
      documentName: "Q4 Business Review",
      creativity: 7,
      colors: {
        primaryColor: "#17191A",
        secondaryColor: "#7D9FD0",
      },
      theme: "Dark",
      language: "English",
      websiteUrl: "https://company.com",
    };
  }

  // Handle special case for Timeline -> Phases in request body type field
  const requestBodyType = slideType === "Timeline" ? "Phases" : slideType;

  return {
    type: requestBodyType as SlideType,
    title: config.title,
    data: config.data,
    presentationID: "1fZuoePN_QEyMJlkpac2-bRq0hQYmeAvAbm21a1FS-CM",
    documentName: "Q4 Business Review",
    creativity: 7,
    colors: {
      primaryColor: "#17191A",
      secondaryColor: "#7D9FD0",
    },
    theme: "Dark",
    language: "English",
    websiteUrl: "https://company.com",
  };
};

// Helper function to validate slide type
export const isValidSlideType = (
  slideType: string
): slideType is keyof typeof SlideType => {
  return Object.values(SlideType).includes(slideType as SlideType);
};

// Helper function to get slide type configuration safely
export const getSlideTypeConfig = (
  slideType: string
): SlideTypeConfig | null => {
  return slideTypeConfigs[slideType] || null;
};

// Array of all available slide types for dropdown
export const availableSlideTypes = Object.keys(slideTypeConfigs);

// Function to generate dynamic code snippets based on slide type
export const generateDynamicCustomSlideSnippets = (
  slideType: string
): Record<TabKey, string> => {
  const requestBody = generateRequestBody(slideType);
  const requestBodyJson = JSON.stringify(requestBody, null, 2);

  // Handle special case for Timeline -> phases in URL
  const urlSlideType =
    slideType === "Timeline" ? "phases" : slideType.toLowerCase();

  return {
    curl: `curl -X POST https://api.zynth.ai/api/v1/data/appscripts/slidecustom/generate-document-slide/your-org-id/${urlSlideType} \\
  -H "Authorization: Bearer YOUR_API_KEY" \\
  -H "Content-Type: application/json" \\
  -d '${requestBodyJson}'`,

    http: `POST api/v1/data/appscripts/slidecustom/generate-document-slide/your-org-id/${urlSlideType} HTTP/1.1
Host: https://api.zynth.ai
Authorization: Bearer YOUR_API_KEY
Content-Type: application/json

${requestBodyJson}`,

    json: requestBodyJson,

    javascript: `fetch("https://api.zynth.ai/api/v1/data/appscripts/slidecustom/generate-document-slide/your-org-id/${urlSlideType}", {
  method: "POST",
  headers: {
    "Authorization": "Bearer YOUR_API_KEY",
    "Content-Type": "application/json"
  },
  body: JSON.stringify(${requestBodyJson.replace(/\n/g, "\n    ")})
});`,
  };
};

export const apiConfig: ApiConfig = {
  title: "API Documentation",
  description:
    "A complete guide to integrating Zynth’s powerful AI-driven presentation capabilities into your own apps and workflows.",
  gettingStarted: {
    apiKey:
      "Before making your first request, create and copy your Zynth.ai API key from your developer dashboard.",
    authentication:
      "All requests must include an API key in the header: Authorization: Bearer YOUR_API_KEY",
  },
  endpoints: [
    {
      id: "generate-presentation",
      title: "1. Generate New Presentation",
      method: "POST",
      path: "https://api.zynth.ai/api/v1/data/appscripts/generate-and-get-url/:orgId",
      description:
        "Generate a new AI presentation based on your input prompt or uploaded document.",
      headers: [
        { name: "Content-Type", value: "application/json" },
        { name: "X-API-Key", value: "<your api token>" },
      ],
      bodyParams: [
        {
          name: "pptInput",
          type: "string",
          description:
            "Input text and instructions relevant to the required presentation.",
          optional: false,
        },
        {
          name: "pdfLink",
          type: "string",
          description:
            "A public link to a PDF which needs to be converted to a presentation.",
          optional: true,
        },
        {
          name: "websiteUrl",
          type: "string",
          description: "A URL to fetch context/data from.",
          optional: true,
        },
        {
          name: "colors",
          type: "object",
          description:
            "Brand color scheme to apply primary (default: #17191A) and secondary colours (default: #7D9FD0).",
          optional: true,
          default: "default",
        },
        {
          name: "creativity",
          type: "number",
          description:
            "Content creativity level between 1 (most structured) to 10 (most creative). Default value: 6",
          optional: true,
          default: "default",
        },
        {
          name: "theme",
          type: "string",
          description:
            'Slide background visual theme ("Light", "Dark", "Branded"). All themes use the branding colours. Default: "Light"',
          optional: true,
          default: "default",
        },
        {
          name: "language",
          type: "string",
          description:
            'Presentation language (e.g., "French"). Refer to the available languages in the Parameter Library section.Default: "English"',
          optional: true,
          default: "None",
        },
        {
          name:"outline",
          type: "array",
          description:
            'An array of slides to be generated. Each slide comprises of title, type, and keywords.',
          optional: true,
          default: "None",
        },
        {
          name: "pptType",
          type: "string",
          description:
            'The type of presentation to be generated in 2-3 words(e.g.,"Pitch Deck","Project Proposal","Employee Engagement").Mandatory to pass if outline is passed.',
          optional: true,
          default: "None",
        }

      ],
      request: {
        pptInput: "",
        pdfLink:
          "https://zynthimage.s3.amazonaws.com/uploads/1749868936240_Working%20sheet%20-%20Sheet1.pdf",
        websiteUrl: "",
        colors: {
          primaryColor: "#17191A",
          secondaryColor: "#7D9FD0",
        },
        creativity: 7,
        theme: "Dark",
        language: "French",
        outline:[
      {
    "title": "Financial Problems Overview",
    "type": "Cover",
    "keywords": "Introduction, Decade Analysis"
      },
    {
    "title": "Key Financial Issues",
    "type": "Points",
    "keywords": "Major Problems, Challenges"
    },
    {
    "title": "Decade Timeline",
    "type": "Phases",
    "keywords": "Chronological Events, Milestones"
    },
    {
    "title": "Contact",
    "type": "Contact",
    "keywords": "Get in Touch, Reach Us"
    }
],
"pptType":"Education"
      },
      response: {
        url: "https://docs.google.com/open?id=1HMZ1xRxOFEdiz8hM00doreoZbf71AczHKtSilzqFx0Y",
        slideCount:12
      },
      availablelanguages:
        "English, Chinese (Simplified), Chinese (Traditional), Spanish, French, German, Portuguese (Brazilian), Portuguese (European), Italian, Russian, Japanese, Korean, Dutch, Arabic (Modern Standard), Polish, Turkish, Vietnamese.",
    },
    {
      id: "generate-custom-slide",
      title: "2. Generate Custom Slide",
      method: "POST",
      path: "https://api.zynth.ai/api/v1/data/appscripts/slidecustom/generate-document-slide/:orgId/:section",
      description:
        "Create a custom slide with full control over content structure and data. Supports multiple slide types including Points, Statistics, Timeline, Images, Tables, People, Graphs, and TextandImage slides.",
      headers: [
        { name: "Content-Type", value: "application/json" },
        { name: "Authorization", value: "Bearer <your api token>" },
      ],
      bodyParams: [
        {
          name: "type",
          type: "string",
          description:
            "Type of slide content (Points, Statistics, Timeline, Images, Tables, People, Graphs, TextandImage).",
          optional: false,
        },
        {
          name: "title",
          type: "string",
          description: "Title of the slide.",
          optional: false,
        },
        {
          name: "data",
          type: "object",
          description:
            "Slide content data structure (varies by slide type as per the request body below).",
          optional: false,
        },
        {
          name: "presentationID",
          type: "string",
          description:
            "Google Slides presentation ID (if slide needs to be added to an existing presentation).",
          optional: true,
        },
        {
          name: "documentName",
          type: "string",
          description: "Name of the document/presentation.",
          optional: true,
        },
        {
          name: "creativity",
          type: "number",
          description:
            "Content creativity level between 1 (most structured) to 10 (most creative).Default value: 6.",
          optional: true,
          default: "5",
        },
        {
          name: "colors",
          type: "object",
          description:
            "Brand color scheme to apply primary (default: #17191A) and secondary colours (default: #7D9FD0).",
          optional: true,
        },
        {
          name: "theme",
          type: "string",
          description: `Slide background visual theme ("Light", "Dark", "Branded"). All themes use the branding colours.Default: “Light”`,
          optional: true,
        },
        {
          name: "language",
          type: "string",
          description:
            'Presentation language (e.g., "French"). Refer to the available languages in the Parameter Library section.',
          optional: true,
          default: "English",
        },
        {
          name: "websiteUrl",
          type: "string",
          description: "A URL to fetch context/data from.",
          optional: true,
        },
      ],
      request: {
        type: "Points",
        title: "Key Market Insights",
        data: {
          slideName: "Key Market Insights",
          pointers: [
            "Market size is projected to grow by 25% annually",
            "Customer acquisition cost has decreased by 15%",
            "Revenue per user increased by 30% this quarter",
          ],
        },
        presentationID: "1fZuoePN_QEyMJlkpac2-bRq0hQYmeAvAbm21a1FS-CM",
        documentName: "Q4 Business Review",
        creativity: 7,
        colors: {
          primaryColor: "#17191A",
          secondaryColor: "#7D9FD0",
        },
        theme: "Dark",
        language: "English",
        websiteUrl: "https://company.com",
      },
      response: {
        url: "https://docs.google.com/presentation/d/1fZuoePN_QEyMJlkpac2-bRq0hQYmeAvAbm21a1FS-CM/edit",
      },
      availablelanguages:
        "English, Chinese (Simplified), Chinese (Traditional), Spanish, French, German, Portuguese (Brazilian), Portuguese (European), Italian, Russian, Japanese, Korean, Dutch, Arabic (Modern Standard), Polish, Turkish, Vietnamese.",
    },
    {
      id: "generate-slide-narrative",
      title: "3. Generate Slide from Narrative",
      method: "POST",
      path: "https://api.zynth.ai/api/v1/data/appscripts/slidenarrative/generate-document-slide/:orgId",
      description:
        "Generate slides based on user-provided prompts or narratives. The AI interprets your input and creates contextually relevant slide content.",
      headers: [
        { name: "Content-Type", value: "application/json" },
        { name: "Authorization", value: "Bearer <your api token>" },
      ],
      bodyParams: [
        {
          name: "type",
          type: "string",
          description:
            "Type of slide content (Points, Statistics, Timeline, Images, Tables, People, Graphs, TextandImage).",
          optional: false,
        },
        {
          name: "title",
          type: "string",
          description: "Title of the slide.",
          optional: false,
        },
        {
          name: "input",
          type: "string",
          description:
            "User narrative or prompt describing what the slide should contain.",
          optional: false,
        },

        {
          name: "data",
          type: "object",
          description:
            "Pass image URL (only relevant for TextandImage and Images slide types).",
          optional: true,
        },
        {
          name: "presentationID",
          type: "string",
          description:
            "Google Slides presentation ID (if slide needs to be added to an existing presentation).",
          optional: true,
        },
        {
          name: "documentName",
          type: "string",
          description: "Name of the document/presentation.",
          optional: true,
        },
        {
          name: "creativity",
          type: "number",
          description:
            "Content creativity level between 1 (most structured) to 10 (most creative). Default value: 6",
          optional: true,
          default: "5",
        },
        {
          name: "colors",
          type: "object",
          description:
            "Brand color scheme to apply primary (default: #17191A) and secondary colours (default: #7D9FD0).",
          optional: true,
        },
        {
          name: "theme",
          type: "string",
          description:
            'Slide background visual theme ("Light", "Dark", "Branded"). All themes use the branding colours.Default: “Light”',
          optional: true,
        },
        {
          name: "language",
          type: "string",
          description:
            'Presentation language (e.g., "French"). Refer to the available languages in the Parameter Library section.',
          optional: true,
          default: "English",
        },
        {
          name: "websiteUrl",
          type: "string",
          description: "A URL to fetch context/data from.",
          optional: true,
        },
      ],
      request: {
        type: "Points",
        title: "Market Analysis Overview",
        input:
          "Create a slide showing our market analysis with key growth metrics, competitive advantages, and future opportunities in the fintech sector",
        data: {
          image:
            "https://zynthimage.s3.amazonaws.com/uploads/1755011465734_images.png",
        },
        presentationID: "1qYY-eTK2vwPQYdOvTJE_6YSjz2tJz1i8VJk_Zf8BHV4",
        documentName: "Market Strategy Presentation",
        creativity: 8,
        colors: {
          primaryColor: "#2E7D32",
          secondaryColor: "#81C784",
        },
        theme: "Light",
        language: "English",
        websiteUrl: "https://company.com",
      },
      response: {
        url: "https://docs.google.com/presentation/d/1qYY-eTK2vwPQYdOvTJE_6YSjz2tJz1i8VJk_Zf8BHV4/edit",
      },
      availablelanguages:
        "English, Chinese (Simplified), Chinese (Traditional), Spanish, French, German, Portuguese (Brazilian), Portuguese (European), Italian, Russian, Japanese, Korean, Dutch, Arabic (Modern Standard), Polish, Turkish, Vietnamese.",
    },
  ],
  support: {
    email: "team@zynth.ai",
    helpCenterUrl: "https://zynth.ai/contact-us",
  },
};
type TabKey = "curl" | "http" | "json" | "javascript";

// Code snippets for Generate Presentation API
export const generatePresentationSnippets: Record<TabKey, string> = {
  curl: `curl -X POST https://api.zynth.ai/api/v1/data/appscripts/generate-and-get-url/:orgId \\
  -H "Authorization: Bearer YOUR_API_KEY" \\
  -H "Content-Type: application/json" \\
  -d '{
    "pptInput": "Generate an Overview of upto 6 slides",
    "pdfLink": "https://zynthimage.s3.amazonaws.com/uploads/1749868936240_Working%20sheet%20-%20Sheet1.pdf",
    "websiteUrl": "",
    "colors": {
      "primaryColor": "#17191A",
      "secondaryColor": "#7D9FD0"
    },
    "creativity": 7,
    "theme": "Dark",
    "language": "French",
//  "outline":[
//   {
//     "title": "Financial Problems Overview",
//     "type": "Cover",
//     "keywords": "Introduction, Decade Analysis"
//   },
//   {
//     "title": "Key Financial Issues",
//     "type": "Points",
//     "keywords": "Major Problems, Challenges"
//   },
//   {
//     "title": "Decade Timeline",
//     "type": "Phases",
//     "keywords": "Chronological Events, Milestones"
//   },
//   {
//     "title": "Contact",
//     "type": "Contact",
//     "keywords": "Get in Touch, Reach Us"
//   }
// ],
// "pptType":"Education"
//You can pass your custom outline like the above as an array.It should have atleast contact,cover slide and can have maximum 20 entries/slides
}'`,
  http: `POST  api/v1/data/appscripts/generate-and-get-url/:orgId HTTP/1.1
Host: https://api.zynth.ai/
Authorization: Bearer YOUR_API_KEY
Content-Type: application/json

{
  "pptInput": "",
  "pdfLink": "https://zynthimage.s3.amazonaws.com/uploads/1749868936240_Working%20sheet%20-%20Sheet1.pdf",
  "websiteUrl": "",
  "colors": {
    "primaryColor": "#17191A",
    "secondaryColor": "#7D9FD0"
  },
  "creativity": 7,
  "theme": "Dark",
  "language": "French",
// "outline":[
//   {
//     "title": "Financial Problems Overview",
//     "type": "Cover",
//     "keywords": "Introduction, Decade Analysis"
//   },
//   {
//     "title": "Key Financial Issues",
//     "type": "Points",
//     "keywords": "Major Problems, Challenges"
//   },
//   {
//     "title": "Decade Timeline",
//     "type": "Phases",
//     "keywords": "Chronological Events, Milestones"
//   },
//   {
//     "title": "Contact",
//     "type": "Contact",
//     "keywords": "Get in Touch, Reach Us"
//   }
// ],
// "pptType":"Education"
//You can pass your custom outline like the above as an array.It should have atleast contact,cover slide and can have maximum 20 entries/slides
}`,
  json: `{
  "pptInput": "",
  "pdfLink": "https://zynthimage.s3.amazonaws.com/uploads/1749868936240_Working%20sheet%20-%20Sheet1.pdf",
  "websiteUrl": "",
  "colors": {
    "primaryColor": "#17191A",
    "secondaryColor": "#7D9FD0"
  },
  "creativity": 7,
  "theme": "Dark",
  "language": "French",
// "outline":[
//   {
//     "title": "Financial Problems Overview",
//     "type": "Cover",
//     "keywords": "Introduction, Decade Analysis"
//   },
//   {
//     "title": "Key Financial Issues",
//     "type": "Points",
//     "keywords": "Major Problems, Challenges"
//   },
//   {
//     "title": "Decade Timeline",
//     "type": "Phases",
//     "keywords": "Chronological Events, Milestones"
//   },
//   {
//     "title": "Contact",
//     "type": "Contact",
//     "keywords": "Get in Touch, Reach Us"
//   }
// ],
// "pptType":"Education"
//You can pass your custom outline like the above as an array.It should have atleast contact,cover slide and can have maximum 20 entries/slides
}`,
  javascript: `fetch("https://api.zynth.ai/api/v1/data/appscripts/generate-and-get-url/:orgId", {
  method: "POST",
  headers: {
    "Authorization": "Bearer YOUR_API_KEY",
    "Content-Type": "application/json"
  },
  body: JSON.stringify({
    pptInput: "",
    pdfLink: "https://zynthimage.s3.amazonaws.com/uploads/1749868936240_Working%20sheet%20-%20Sheet1.pdf",
    websiteUrl: "",
    colors: {
      "primaryColor": "#17191A",
      "secondaryColor": "#7D9FD0"
    },
    creativity: 7,
    theme: "Dark",
    language: "French",
//  "outline":[
//   {
//     "title": "Financial Problems Overview",
//     "type": "Cover",
//     "keywords": "Introduction, Decade Analysis"
//   },
//   {
//     "title": "Key Financial Issues",
//     "type": "Points",
//     "keywords": "Major Problems, Challenges"
//   },
//   {
//     "title": "Decade Timeline",
//     "type": "Phases",
//     "keywords": "Chronological Events, Milestones"
//   },
//   {
//     "title": "Contact",
//     "type": "Contact",
//     "keywords": "Get in Touch, Reach Us"
//   }
// ],
// "pptType":"Education"
//You can pass your custom outline like the above as an array.It should have atleast contact,cover slide and can have maximum 20 entries/slides
  })
});`,
};
// Code snippets for Generate Custom Slide API (now uses dynamic generation)
// This function generates code snippets based on the selected slide type
export const generateCustomSlideSnippets = (
  slideType: string = "Points"
): Record<TabKey, string> => {
  return generateDynamicCustomSlideSnippets(slideType);
};

// Static version for backward compatibility (defaults to Points)
export const staticGenerateCustomSlideSnippets: Record<TabKey, string> =
  generateDynamicCustomSlideSnippets("Points");

// Code snippets for Generate Slide Narrative API
export const generateSlideNarrativeSnippets: Record<TabKey, string> = {
  curl: `curl -X POST https://d2bwumaosaqsqc.cloudfront.net/api/v1/data/appscripts/slidenarrative/your-org-id \\
  -H "Authorization: Bearer YOUR_API_KEY" \\
  -H "Content-Type: application/json" \\
  -d '{
  "input": "Extract/Generate relevant points",
  "type": "Points",
  "title": "Team Introduction",
  //"data": {"image": "https://zynthimage.s3.amazonaws.com/uploads/1755011465734_images.png"},
   //You can pass imageurl like the above for textandimage and images slide type only one image is allowed in slide narrative,
  "presentationID": "1r76G7oK80Dh9jehlS1XJe21bC7nQclBt16lXb9bpLIs",
  "websiteUrl": "",
  "creativity": 7,
  "theme": "Dark",
  "language": "English",
  "colors": {
    "primaryColor": "#F54927",
    "secondaryColor": "#2E2120"
  }
}
'`,
  http: `POST api/v1/data/appscripts/slidenarrative/your-org-id HTTP/1.1
Host: https://d2bwumaosaqsqc.cloudfront.net
Authorization: Bearer YOUR_API_KEY
Content-Type: application/json
{
  "input": "Extract/Generate relevant points",
  "type": "Points",
  "title": "Team Introduction",
  //"data": {"image": "https://zynthimage.s3.amazonaws.com/uploads/1755011465734_images.png"}, 
  //You can pass imageurl like the above for textandimage and images slide type only one image is allowed in slide narrative
  "presentationID": "1r76G7oK80Dh9jehlS1XJe21bC7nQclBt16lXb9bpLIs",
  "websiteUrl": "",
  "creativity": 7,
  "theme": "Dark",
  "language": "English",
  "colors": {
    "primaryColor": "#F54927",
    "secondaryColor": "#2E2120"
  }
}
`,
  json: `{
  "input": "Extract/Generate relevant points",
  "type": "Points",
  "title": "Team Introduction",
  //"data": {"image": "https://zynthimage.s3.amazonaws.com/uploads/1755011465734_images.png"},
  //You can pass imageurl like the above for textandimage and images slide type only one image is allowed in slide narrative
  "presentationID": "1r76G7oK80Dh9jehlS1XJe21bC7nQclBt16lXb9bpLIs",
  "websiteUrl": "",
  "creativity": 7,
  "theme": "Dark",
  "language": "English",
  "colors": {
    "primaryColor": "#F54927",
    "secondaryColor": "#2E2120"
  }
}
`,
  javascript: `fetch("https://d2bwumaosaqsqc.cloudfront.net/api/v1/data/appscripts/slidenarrative/your-org-id", {
  method: "POST",
  headers: {
    "Authorization": "Bearer YOUR_API_KEY",
    "Content-Type": "application/json"
  },
  body: JSON.stringify({
  "input": "Extract/Generate relevant points",
  "type": "Points",
  "title": "Team Introduction",
  // "data": {"image": "https://zynthimage.s3.amazonaws.com/uploads/1755011465734_images.png"},
  // You can pass imageurl like the above for textandimage and images slide type only one image is allowed in slide narrative
  "presentationID": "1r76G7oK80Dh9jehlS1XJe21bC7nQclBt16lXb9bpLIs",
  "websiteUrl": "",
  "creativity": 7,
  "theme": "Dark",
  "language": "English",
  "colors": {
    "primaryColor": "#F54927",
    "secondaryColor": "#2E2120"
  }
})
});`,
};

// Map of API IDs to their code snippets
export const apiCodeSnippets: Record<string, Record<TabKey, string>> = {
  "generate-presentation": generatePresentationSnippets,
  "generate-custom-slide": staticGenerateCustomSlideSnippets,
  "generate-slide-narrative": generateSlideNarrativeSnippets,
};

// Legacy export for backward compatibility
export const codeSnippets = generatePresentationSnippets;
